import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-099b52c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "lead mb-2"
}
const _hoisted_4 = { class: "row gap-y-3" }
const _hoisted_5 = ["alt"]
const _hoisted_6 = {
  key: 0,
  class: "lead"
}
const _hoisted_7 = { class: "mb-0 font-weight-bold" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right ml-auto mr-2" }, null, -1))
const _hoisted_9 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["block", _ctx.blockBackgroundClass(_ctx.vm.backgroundColor)])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.vm.title)
        ? (_openBlock(), _createElementBlock("h2", {
            key: 0,
            class: _normalizeClass(["display-4", { 'mb-0': _ctx.vm.subTitle }]),
            innerHTML: _ctx.vm.title
          }, null, 10, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.vm.subTitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.vm.subTitle), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `categoryBlockItem_${index}`,
            class: _normalizeClass(_ctx.columnWidth)
          }, [
            _createVNode(_component_LinkButton, {
              class: "category-item-button",
              target: item.linkItem.target,
              url: item.linkItem.url
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("img", {
                  alt: item.imageAlt,
                  class: "mr-2",
                  height: "80"
                }, null, 8, _hoisted_5), [
                  [_directive_lazy, item.imageUrl]
                ]),
                _createElementVNode("div", null, [
                  (item.linkItem.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(item.linkItem.title), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("h4", _hoisted_7, _toDisplayString(item.linkItem.text), 1)
                ]),
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["target", "url"])
          ], 2))
        }), 128)),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.vm.ctaLinkItem)
            ? (_openBlock(), _createBlock(_component_LinkButton, {
                key: 0,
                class: _normalizeClass(_ctx.ctaButtonClass(_ctx.vm.ctaStyle) || 'p-button-arrow p-button-raised p-button-text'),
                label: _ctx.vm.ctaLinkItem.text,
                target: _ctx.vm.ctaLinkItem.target,
                title: _ctx.vm.ctaLinkItem.title,
                url: _ctx.vm.ctaLinkItem.url
              }, null, 8, ["class", "label", "target", "title", "url"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}